import { render } from "./OnboardingBoxSelect.vue?vue&type=template&id=feee1546&scoped=true"
import script from "./OnboardingBoxSelect.vue?vue&type=script&lang=js"
export * from "./OnboardingBoxSelect.vue?vue&type=script&lang=js"

import "./OnboardingBoxSelect.vue?vue&type=style&index=0&id=feee1546&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feee1546"],['__file',"src/scripts/portfolioManager/onboarding/components/OnboardingBoxSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "feee1546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('feee1546', __exports__)) {
    api.reload('feee1546', __exports__)
  }
  
  module.hot.accept("./OnboardingBoxSelect.vue?vue&type=template&id=feee1546&scoped=true", () => {
    api.rerender('feee1546', render)
  })

}


export default __exports__